var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "campaign"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_1135",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_1135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "campaign_2",
    d: "M20.827 12.75H18.7115C18.4987 12.75 18.3205 12.6782 18.177 12.5345C18.0333 12.391 17.9615 12.2128 17.9615 12C17.9615 11.7872 18.0333 11.609 18.177 11.4655C18.3205 11.3218 18.4987 11.25 18.7115 11.25H20.827C21.0398 11.25 21.218 11.3218 21.3615 11.4655C21.5052 11.609 21.577 11.7872 21.577 12C21.577 12.2128 21.5052 12.391 21.3615 12.5345C21.218 12.6782 21.0398 12.75 20.827 12.75ZM16.6673 16.7135C16.7954 16.5378 16.9593 16.4365 17.1588 16.4095C17.3581 16.3827 17.5456 16.4333 17.7213 16.5615L19.4078 17.8287C19.5834 17.9571 19.6847 18.1209 19.7115 18.3202C19.7385 18.5196 19.6878 18.7071 19.5595 18.8827C19.4313 19.0582 19.2676 19.1595 19.0683 19.1865C18.8689 19.2135 18.6814 19.1628 18.5058 19.0345L16.8193 17.7673C16.6436 17.6391 16.5423 17.4753 16.5155 17.276C16.4885 17.0767 16.5391 16.8892 16.6673 16.7135ZM19.3693 6.13275L17.6828 7.4C17.5071 7.52817 17.3196 7.57883 17.1203 7.552C16.9209 7.525 16.7571 7.42367 16.6288 7.248C16.5006 7.0725 16.45 6.885 16.477 6.6855C16.5038 6.48617 16.6051 6.32242 16.7807 6.19425L18.4673 4.927C18.6429 4.79883 18.8304 4.74817 19.0298 4.775C19.2291 4.802 19.3929 4.90325 19.5212 5.07875C19.6494 5.25442 19.7 5.44192 19.673 5.64125C19.6462 5.84075 19.5449 6.00458 19.3693 6.13275ZM5.25 14.577H4.23075C3.73208 14.577 3.30617 14.4003 2.953 14.047C2.59967 13.6938 2.423 13.2679 2.423 12.7692V11.2307C2.423 10.7321 2.59967 10.3062 2.953 9.953C3.30617 9.59967 3.73208 9.423 4.23075 9.423H8.09625L11.2057 7.5635C11.5071 7.38267 11.8109 7.38108 12.1173 7.55875C12.4238 7.73625 12.577 7.99742 12.577 8.34225V15.6577C12.577 16.0026 12.4238 16.2637 12.1173 16.4412C11.8109 16.6189 11.5071 16.6173 11.2057 16.4365L8.09625 14.577H6.75V17.7307C6.75 17.9436 6.67817 18.1217 6.5345 18.2652C6.391 18.4089 6.21283 18.4807 6 18.4807C5.78717 18.4807 5.609 18.4089 5.4655 18.2652C5.32183 18.1217 5.25 17.9436 5.25 17.7307V14.577ZM11.077 14.5847V9.41525L8.5115 10.923H4.23075C4.15392 10.923 4.08342 10.9551 4.01925 11.0192C3.95508 11.0834 3.923 11.1539 3.923 11.2307V12.7692C3.923 12.8461 3.95508 12.9166 4.01925 12.9807C4.08342 13.0449 4.15392 13.077 4.23075 13.077H8.5115L11.077 14.5847ZM13.9615 15.1192V8.88075C14.3538 9.23592 14.6698 9.68333 14.9095 10.223C15.1493 10.7628 15.2693 11.3552 15.2693 12C15.2693 12.6448 15.1493 13.2372 14.9095 13.777C14.6698 14.3167 14.3538 14.7641 13.9615 15.1192Z",
    fill: "var(--fill-0, white)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaign);
export default __webpack_public_path__ + "static/media/icon-campaign.0691e3974fe73a1d41a2f46525bd7ff8.svg";
export { ForwardRef as ReactComponent };